import { useState, useEffect } from 'react';

export const useGeolocation = () => {

  const [currentCoords, setCurrentCoords] = useState({ lat: 43.7153176, lng: -79.5178468 });
  const [isGeoOn, setIsGeoOn] = useState(false);

  useEffect(() => {
    //const timer = setInterval(() => { // Creates an interval which will update the current data every minute
      // This will trigger a rerender every component that uses the useDate hook.
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const { latitude, longitude } = pos.coords;
            setCurrentCoords({lat:latitude,lng:longitude});
            setIsGeoOn(true);
          },
          () => {
            setIsGeoOn(false);
          },
          { enableHighAccuracy: true, maximumAge: 0, timeout: 27000 }
        );
      } else {
        // Geolocation not supported, use default
        setIsGeoOn(false);
      }
    /*}, 60 * 1000);
    return () => {
      clearInterval(timer); // Return a funtion to clear the timer so that it will stop being called on unmount
    }*/
  }, []);

  return {
    isGeoOn,
    currentCoords
  };
};